import template from './history_table.template.html';

class HistoryTableController {
  constructor($resource) {
    this.$resource = $resource;

    this.loadHistory = () => {
      const { id, type } = this;

      if (!type) {
        throw new Error(
          "Attribute 'type' must be provided to the history table",
        );
      }

      if (!id) {
        this.historyDiffs = [];
        this.historyLoaded = true;
        return;
      }

      this.historyLoaded = false;

      this.$resource('/history/:type/:id', { id: '@id', type: '@type' })
        .query({ id, type })
        .$promise.then(configHistory => {
          this.historyDiffs = configHistory.reduce((acc, cur) => {
            if (cur.diffs.length > 0) {
              cur.diffs[cur.diffs.length - 1].count = cur.diffs.length;
              cur.diffs.forEach(diff => {
                if (diff.from === 'Lock Box')
                  diff.from = 'Combination Lock Box';
                if (diff.to === 'Lock Box') diff.to = 'Combination Lock Box';
              });

              return acc.concat(cur.diffs);
            }

            return acc;
          }, []);
          this.historyLoaded = true;
        })
        .catch(() => {
          this.historyDiffs = [];
          this.historyLoaded = true;
        });
    };

    this.$onInit = () => {
      this.loadHistory();
    };
  }
}

HistoryTableController.$inject = ['$resource'];

angular.module('bb.history').component('historyTable', {
  bindings: {
    id: '=',
    type: '@',
  },
  controller: HistoryTableController,
  template,
});
